import * as React from 'react';
import { Component } from 'react';

import './theme/aspect-ratio.css';

const CUSTOM_PROPERTY_NAME = '--aspect-ratio';
const DEFAULT_CLASS_NAME = 'react-aspect-ratio-placeholder';


export class AspectRatio extends Component {
	static defaultProps = {
		className: DEFAULT_CLASS_NAME,
		ratio: 1,
	};

	node = null;

	componentDidUpdate() {
		if (this.node) {
			const { node } = this;

			// BC for older version of React https://github.com/facebook/react/issues/6411
			// check if React support custom property AFTER
			const customPropertyValue = node.style.getPropertyValue(CUSTOM_PROPERTY_NAME);
			if (!customPropertyValue) {
				node.style.setProperty(CUSTOM_PROPERTY_NAME, `(${this.props.ratio})`);
			}
		}
	}

	setNode = (node: any): void => {
		this.node = node;
	};

	render() {
		const { children, ratio, style, className, ...restProps } = this.props; // eslint-disable-line no-unused-vars

		const newStyle = {
			...style,
			[CUSTOM_PROPERTY_NAME]: `(${ratio})`,
		};

		const finalClassName =
			className !== DEFAULT_CLASS_NAME ? `${className} ${DEFAULT_CLASS_NAME}` : DEFAULT_CLASS_NAME;

		return (
			<div {...restProps} className={finalClassName} ref={this.setNode} style={newStyle}>
				{children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// src/components/aspect-ratio/aspect-ratio.jsx